import {
  cardCouponSectionItemStyles,
  subscriptionModalSectionWrapperStyles
} from '@anm/styles/helpers';
import styled from 'styled-components';

export const DiscountInfoWrapper = styled.div`
  ${subscriptionModalSectionWrapperStyles};
`;

export const DiscountInfoTitle = styled.div`
  ${cardCouponSectionItemStyles};
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  min-height: auto;
`;

export const DiscountInfoDescription = styled.div`
  ${cardCouponSectionItemStyles};
  padding-top: 11px;
`;

export const DiscountInfoDescriptionItem = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const DiscountInfoDescriptionItemText = styled.div`
  margin-bottom: 10px;
  color: #a0a0a7;
`;

export const PeriodName = styled.span`
  text-transform: capitalize;
`;

export const DiscountView = styled.span`
  color: #417505;
  &:before {
    content: '–';
    display: inline;
  }
`;
